import * as React from 'react';

export function useDebouncedValue<T>(value: T, onChange: (value: T) => void, delayMs: number) {
  const [draft, setDraft] = React.useState(value);
  const lastEmittedValue = React.useRef(value);
  const emitChange = React.useEffectEvent(onChange);

  React.useEffect(() => {
    if (!Object.is(value, lastEmittedValue.current)) setDraft(value);
    lastEmittedValue.current = value;
  }, [value]);

  React.useEffect(() => {
    if (Object.is(draft, value)) return;
    const timeoutId = window.setTimeout(() => {
      lastEmittedValue.current = draft;
      emitChange(draft);
    }, delayMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, draft, value]);

  return {
    draft,
    setDraft,
  };
}
